<template>

    <div class="col-12 mb-4 mt-4">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ name: 'unemployedPrivateCoachingDocuments', params: { id: unemployed.id } }"
              :class="{ active: $route.name === 'unemployedPrivateCoachingDocuments' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Einzelcoaching ( {{ documentCounts.privateCoachingDigitalDocumentCount }} )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{ }"
              :class="{ active: $route.name === 'unemployedGroupCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Gruppenmaßnahmen ( 0 )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{  }"
              :class="{ active: $route.name === 'unemployedSocioTherapyCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Soziotherapie ( 0 )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{  }"
              :class="{ active: $route.name === 'unemployedAssistedLivingCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Betreutes Wohnen ( 0 )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{  }"
              :class="{ active: $route.name === 'unemployedCaseManagementCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            DRV Fallmanagement ( 0 )
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ'"
              :to="{  }"
              :class="{ active: $route.name === 'unemployedPrivateLearningCoachingList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Private Weiterbildung ( 0 )
          </router-link>
        </div>
      </nav>
    </div>
</template>

<script setup>
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed, defineProps } from 'vue';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole  = piniaCurrentUser.value.roles[ 0 ];

const props = defineProps({
  unemployed: {
    type: Object,
    require: true,
  },
  documentCounts: {
    type: Object,
    require: true,
  },
});
</script>

<style scoped>

</style>